export const focusGrid = () => {
  // Set focus back to Grid
  document.getElementById('QuadraticCanvasID')?.focus();
};
